
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/homeowners",
      function () {
        return require("private-next-pages/fr/en/homeowners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/homeowners"])
      });
    }
  